import { Col, Form, Row } from 'antd';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { routeFileSelector } from '../../../../../utilz/i18n';
import FormInput from '../../../../components/Inputs/FormInput';
import FormRadioGroup from '../../../../components/Inputs/FormRadioGroup';
import FormLabel from '../../../../components/Labels/FormLabel';
import TransportationProviderSelector from '../../../../components/Selectors/AsynchSearch/TransportationProviderSelector';
import ShipmentCreatedBySelector from '../../../../components/Selectors/ShipmentCreatedBySelector';
import ShipmentProductClassSelector from '../../../../components/Selectors/ShipmentProductClassSelector';
import TransportationGroupSelector from '../../../../components/Selectors/TransportationGroupSelector';
import TransportationModeSelector from '../../../../components/Selectors/TransportationModeSelector';
import UrgencySelector from '../../../../components/Selectors/UrgencySelector';

const AdditionalQuoteSearchOptions = ({ form }) => {
  const { pathname: activeTab } = useLocation();
  const namespace = useMemo(() => routeFileSelector(activeTab), [activeTab]);
  const { t } = useTranslation([namespace, 'translation']);

  const createdByType = Form.useWatch('createdByType', form);

  return (
    <Row className="pt-10">
      <Col sm={24} className="mb-16">
        <TransportationProviderSelector
          name="transporterKey"
          form={form}
          showPopupFilter
          margin="mb-16"
          labelForTestId="search-quote"
        />
        <TransportationModeSelector name="transportationMode" label={t('translation:default.fields.mode')} editMode />
        <TransportationGroupSelector name="transportationGroup" />
        <UrgencySelector name="urgency" />
        <FormInput name="shipmentNumber" editMode label={t('translation:default.fields.shipmentNumber.label')} />
        <FormInput name="poNumber" label={t('translation:default.fields.poNumber')} editMode margin="m-0" />
      </Col>
      <Col sm={24}>
        <FormLabel>{t('translation:shipment.drawer.details.createdBy')}</FormLabel>
        <div className="mb-5">
          <FormRadioGroup
            options={[
              {
                label: t('translation:default.fields.userName.label'),
                value: 1,
              },
              {
                label: t('translation:shipment.filter.additionalSearchOptions.createdBy.radioEmail'),
                value: 2,
              },
            ]}
            label={t('translation:default.fields.userName.label')}
            name="createdByType"
          />
        </div>
        <ShipmentCreatedBySelector label="" createdType={createdByType} name="createdBy" mode="multiple" />
        <ShipmentProductClassSelector
          name="hazardousClass"
          label={t('translation:getQuote.productDetails.hazardousClass.label')}
          placeholder={t('translation:getQuote.productDetails.hazardousClass.placeholder')}
          margin="m-0"
        />
      </Col>
    </Row>
  );
};

export default AdditionalQuoteSearchOptions;
